import React from 'react';

const HANDLE = 'whapaxxgaming';

const socials = [
  {
    name: 'Instagram',
    url: `https://instagram.com/${HANDLE}`,
    color: '#E1306C',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    name: 'TikTok',
    url: `https://www.tiktok.com/@${HANDLE}`,
    color: '#ff0050',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.87a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.3z"/>
      </svg>
    ),
  },
  {
    name: 'Facebook',
    url: `https://www.facebook.com/${HANDLE}`,
    color: '#1877F2',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
];

/**
 * Social media icon links.
 * variant: "icons" (icon-only circles) | "labeled" (icon + name)
 */
export default function SocialIcons({ variant = 'icons', style: wrapStyle = {} }) {
  if (variant === 'labeled') {
    return (
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', ...wrapStyle }}>
        {socials.map(s => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            title={`@${HANDLE} on ${s.name}`}
            className="btn-neon"
            style={styles.labeledLink}
          >
            <span style={styles.labeledInner}>
              {s.icon}
              {s.name}
            </span>
          </a>
        ))}
      </div>
    );
  }

  // Default: icon-only circles
  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', ...wrapStyle }}>
      {socials.map(s => (
        <a
          key={s.name}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          title={`@${HANDLE} on ${s.name}`}
          style={{
            ...styles.iconCircle,
            '--hover-color': s.color,
          }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = s.color;
            e.currentTarget.style.color = s.color;
            e.currentTarget.style.boxShadow = `0 0 14px ${s.color}40`;
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(18,208,255,0.25)';
            e.currentTarget.style.color = '#a8b2ff';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          {s.icon}
        </a>
      ))}
    </div>
  );
}

const styles = {
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '1px solid rgba(18,208,255,0.25)',
    background: 'rgba(18,208,255,0.04)',
    color: '#a8b2ff',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
  },
  labeledLink: {
    textDecoration: 'none',
    padding: '8px 16px',
    fontSize: '0.75rem',
  },
  labeledInner: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  },
};
